// Classic 5x7 bitmap font, rendered to per-color atlases so that drawing text is just blits.

const GLYPHS: number[] = [
  0x00,0x00,0x00,0x00,0x00, 0x00,0x00,0x5f,0x00,0x00, 0x00,0x07,0x00,0x07,0x00, 0x14,0x7f,0x14,0x7f,0x14,
  0x24,0x2a,0x7f,0x2a,0x12, 0x23,0x13,0x08,0x64,0x62, 0x36,0x49,0x55,0x22,0x50, 0x00,0x05,0x03,0x00,0x00,
  0x00,0x1c,0x22,0x41,0x00, 0x00,0x41,0x22,0x1c,0x00, 0x14,0x08,0x3e,0x08,0x14, 0x08,0x08,0x3e,0x08,0x08,
  0x00,0x50,0x30,0x00,0x00, 0x08,0x08,0x08,0x08,0x08, 0x00,0x60,0x60,0x00,0x00, 0x20,0x10,0x08,0x04,0x02,
  0x3e,0x51,0x49,0x45,0x3e, 0x00,0x42,0x7f,0x40,0x00, 0x42,0x61,0x51,0x49,0x46, 0x21,0x41,0x45,0x4b,0x31,
  0x18,0x14,0x12,0x7f,0x10, 0x27,0x45,0x45,0x45,0x39, 0x3c,0x4a,0x49,0x49,0x30, 0x01,0x71,0x09,0x05,0x03,
  0x36,0x49,0x49,0x49,0x36, 0x06,0x49,0x49,0x29,0x1e, 0x00,0x36,0x36,0x00,0x00, 0x00,0x56,0x36,0x00,0x00,
  0x08,0x14,0x22,0x41,0x00, 0x14,0x14,0x14,0x14,0x14, 0x00,0x41,0x22,0x14,0x08, 0x02,0x01,0x51,0x09,0x06,
  0x32,0x49,0x79,0x41,0x3e, 0x7e,0x11,0x11,0x11,0x7e, 0x7f,0x49,0x49,0x49,0x36, 0x3e,0x41,0x41,0x41,0x22,
  0x7f,0x41,0x41,0x22,0x1c, 0x7f,0x49,0x49,0x49,0x41, 0x7f,0x09,0x09,0x09,0x01, 0x3e,0x41,0x49,0x49,0x7a,
  0x7f,0x08,0x08,0x08,0x7f, 0x00,0x41,0x7f,0x41,0x00, 0x20,0x40,0x41,0x3f,0x01, 0x7f,0x08,0x14,0x22,0x41,
  0x7f,0x40,0x40,0x40,0x40, 0x7f,0x02,0x0c,0x02,0x7f, 0x7f,0x04,0x08,0x10,0x7f, 0x3e,0x41,0x41,0x41,0x3e,
  0x7f,0x09,0x09,0x09,0x06, 0x3e,0x41,0x51,0x21,0x5e, 0x7f,0x09,0x19,0x29,0x46, 0x46,0x49,0x49,0x49,0x31,
  0x01,0x01,0x7f,0x01,0x01, 0x3f,0x40,0x40,0x40,0x3f, 0x1f,0x20,0x40,0x20,0x1f, 0x3f,0x40,0x38,0x40,0x3f,
  0x63,0x14,0x08,0x14,0x63, 0x07,0x08,0x70,0x08,0x07, 0x61,0x51,0x49,0x45,0x43, 0x00,0x7f,0x41,0x41,0x00,
  0x02,0x04,0x08,0x10,0x20, 0x00,0x41,0x41,0x7f,0x00, 0x04,0x02,0x01,0x02,0x04, 0x40,0x40,0x40,0x40,0x40,
  0x00,0x01,0x02,0x04,0x00, 0x20,0x54,0x54,0x54,0x78, 0x7f,0x48,0x44,0x44,0x38, 0x38,0x44,0x44,0x44,0x20,
  0x38,0x44,0x44,0x48,0x7f, 0x38,0x54,0x54,0x54,0x18, 0x08,0x7e,0x09,0x01,0x02, 0x0c,0x52,0x52,0x52,0x3e,
  0x7f,0x08,0x04,0x04,0x78, 0x00,0x44,0x7d,0x40,0x00, 0x20,0x40,0x44,0x3d,0x00, 0x7f,0x10,0x28,0x44,0x00,
  0x00,0x41,0x7f,0x40,0x00, 0x7c,0x04,0x18,0x04,0x78, 0x7c,0x08,0x04,0x04,0x78, 0x38,0x44,0x44,0x44,0x38,
  0x7c,0x14,0x14,0x14,0x08, 0x08,0x14,0x14,0x18,0x7c, 0x7c,0x08,0x04,0x04,0x08, 0x48,0x54,0x54,0x54,0x20,
  0x04,0x3f,0x44,0x40,0x20, 0x3c,0x40,0x40,0x20,0x7c, 0x1c,0x20,0x40,0x20,0x1c, 0x3c,0x40,0x30,0x40,0x3c,
  0x44,0x28,0x10,0x28,0x44, 0x0c,0x50,0x50,0x50,0x3c, 0x44,0x64,0x54,0x4c,0x44, 0x00,0x08,0x36,0x41,0x00,
  0x00,0x00,0x7f,0x00,0x00, 0x00,0x41,0x36,0x08,0x00, 0x10,0x08,0x08,0x10,0x08,
];

// Real descenders: the classic table squeezes these into the x-height, where g reads as 9.
const DESCENDERS: Record<string, number[]> = {
  g: [0x98, 0xa4, 0xa4, 0xa4, 0x7c],
  j: [0x80, 0x80, 0x80, 0x7d, 0x00],
  p: [0xfc, 0x24, 0x24, 0x24, 0x18],
  q: [0x18, 0x24, 0x24, 0x24, 0xfc],
  y: [0x9c, 0xa0, 0xa0, 0xa0, 0x7c],
};
for (const ch of Object.keys(DESCENDERS)) {
  const at = (ch.charCodeAt(0) - 32) * 5;
  DESCENDERS[ch].forEach((bits, i) => (GLYPHS[at + i] = bits));
}

const CHAR_W = 6;
const CHAR_H = 8;
const COUNT = 95;

const atlases = new Map<string, HTMLCanvasElement>();

function atlas(color: string): HTMLCanvasElement {
  let c = atlases.get(color);
  if (c) return c;
  c = document.createElement('canvas');
  c.width = CHAR_W * COUNT;
  c.height = CHAR_H;
  const ctx = c.getContext('2d')!;
  ctx.fillStyle = color;
  for (let i = 0; i < COUNT; i++) {
    for (let col = 0; col < 5; col++) {
      const bits = GLYPHS[i * 5 + col];
      for (let row = 0; row < CHAR_H; row++) {
        if (bits & (1 << row)) ctx.fillRect(i * CHAR_W + col, row, 1, 1);
      }
    }
  }
  atlases.set(color, c);
  return c;
}

export function textWidth(s: string, scale = 1): number {
  return s.length * CHAR_W * scale;
}

export const LINE_H = 9;

export interface TextOpts {
  scale?: number;
  shadow?: string | null;
  align?: 'left' | 'center' | 'right';
}

export function drawText(ctx: CanvasRenderingContext2D, s: string, x: number, y: number, color = '#fcfcfc', opts: TextOpts = {}): void {
  const scale = opts.scale ?? 1;
  const shadow = opts.shadow === undefined ? '#000000' : opts.shadow;
  let px = Math.round(x);
  const py = Math.round(y);
  if (opts.align === 'center') px -= Math.floor(textWidth(s, scale) / 2);
  else if (opts.align === 'right') px -= textWidth(s, scale);
  if (shadow) blit(ctx, s, px + scale, py + scale, shadow, scale);
  blit(ctx, s, px, py, color, scale);
}

function blit(ctx: CanvasRenderingContext2D, s: string, x: number, y: number, color: string, scale: number): void {
  const a = atlas(color);
  for (let i = 0; i < s.length; i++) {
    const code = s.charCodeAt(i) - 32;
    if (code <= 0 || code >= COUNT) continue;
    ctx.drawImage(a, code * CHAR_W, 0, CHAR_W, CHAR_H, x + i * CHAR_W * scale, y, CHAR_W * scale, CHAR_H * scale);
  }
}

/** Word-wrap to a pixel width. */
export function wrapText(s: string, maxWidth: number): string[] {
  const maxChars = Math.max(4, Math.floor(maxWidth / CHAR_W));
  const lines: string[] = [];
  for (const para of s.split('\n')) {
    let cur = '';
    for (const word of para.split(' ')) {
      if (!cur.length) cur = word;
      else if (cur.length + 1 + word.length <= maxChars) cur += ' ' + word;
      else {
        lines.push(cur);
        cur = word;
      }
    }
    lines.push(cur);
  }
  return lines;
}
